import { LogsDownloadUrlData } from "./gql";

export const getLogsDownloadUrl = (data?: LogsDownloadUrlData) => {
  if (!data) {
    return undefined;
  }

  const entity = "module" in data ? data.module : data.stack;

  return entity?.run?.logsDownloadURL;
};

export const getLogsUnavailableMessage = (
  logs?: { deleted: boolean; expired: boolean; ongoing: boolean } | null
) => {
  // `deleted` implies `expired`, so it has to win to avoid blaming the retention period.
  if (logs?.deleted) {
    return "These logs were deleted by an administrator and are no longer available for download.";
  }

  if (logs?.expired) {
    return "Logs have expired and are no longer available for download.";
  }

  if (logs?.ongoing) {
    return "Logs will be available for download once this phase completes.";
  }

  return "Logs are not yet available for download. Please try again later.";
};

export const getLogsUnavailableReason = (expired: boolean, deleted: boolean) => {
  if (deleted) {
    return "These logs were deleted by an administrator.";
  }

  if (expired) {
    return "These logs have expired.";
  }

  return undefined;
};
